/*-----------------------------------------------------------------------------/
/ Custom Theme JS = Has been added by Sam
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener('DOMContentLoaded', function () {
  var note = document.getElementById('Cart-note');
  var feedback = document.getElementById('Cart-note_feedback');

  if (!note || !feedback || note.maxLength <= 0) return;

  feedback.textContent = note.maxLength + ' characters remaining';

  note.addEventListener('input', function () {
    feedback.textContent =
      (note.maxLength - note.value.length) + ' characters remaining';
  });
});

window.addEventListener('drawer_open_done', function () {
  if (window.Zapiet && window.ZapietCachedSettings) {
    Zapiet.start(ZapietCachedSettings);
  }
});

window.addEventListener('cart_update_done', function () {
  if (window.Zapiet && window.ZapietCachedSettings) {
    Zapiet.start(ZapietCachedSettings);
  }
});



//Table Search Functionality // 


function myFunction() {
  // Declare variables
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("myInput");
  filter = input.value.toUpperCase();
  table = document.getElementById("myTable");
  tr = table.getElementsByTagName("tr");

  // Loop through all table rows, and hide those who don't match the search query
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[0];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}
function myFunction2() {
  // Declare variables
  var input, filter, table, tr, td, i, txtValue;
  input = document.getElementById("myInput2");
  filter = input.value.toUpperCase();
  table = document.getElementById("myTable");
  tr = table.getElementsByTagName("tr");

  // Loop through all table rows, and hide those who don't match the search query
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[1];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}

/*-----------------------------------------------------------------------------/
/ End Additions by Sam
/-----------------------------------------------------------------------------*/